import axios from 'axios'
import { API_BASE } from '../config'

export default class News {
    // GET /news - Returns all news posts, newest first
    getNews() {
        return axios.get(`${API_BASE}/news`).then(x => x.data);
    }

}
